import { YonetimAnaSayfaPage } from './../Yonetim/yonetim-ana-sayfa/yonetim-ana-sayfa';
import { BllProgramAyarlari } from './../../providers/bll/bll-programayarlari';
import { NL_ProgramAyarlari } from './../../models/NL_ProgramAyarlari';
import { BllOrtak } from './../../providers/bll/bll-ortak';
import { Ortak } from './../../providers/ortak';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ViewController } from 'ionic-angular/navigation/view-controller';

/**
 * Generated class for the ProgramAyarlariPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-program-ayarlari',
  templateUrl: 'program-ayarlari.html',
})
export class ProgramAyarlariPage {
  yaziciAdi: any;
  FisYaziciAdi="";
  yaziciListesi = [];
  BarkodYaziciAdi = "";
 
  firmabigileri:any={ID:-1,SiparisNo:""};
  constructor(public navCtrl: NavController,
    public ortak: Ortak,
    public viewCtrl:ViewController,
    public bllOrtak: BllOrtak,
    public navParams: NavParams) {

  }

  ionViewDidLoad() {
   // this.ayarlarigetir();
    this.YazicilariGetir();
 
    // this.BarkodSablonGetir();
  }
  ayarlarigetir() {
    var bllprogramayarlari = new BllProgramAyarlari();
    bllprogramayarlari.getAll().then(a => {
      var sonuc = <any>a;
      this.BarkodYaziciAdi = sonuc[0].YaziciAdi;
      this.FisYaziciAdi=sonuc[0].FisYaziciAdi;

    });
  }
  Kaydet() {
    var bllayar = new BllProgramAyarlari();
    var guncellenecekElement = new NL_ProgramAyarlari();
    guncellenecekElement.BarkodYaziciAdi = this.BarkodYaziciAdi;
    guncellenecekElement.FisYaziciAdi=this.FisYaziciAdi;

    guncellenecekElement.ID = 1;
    bllayar.YaziciAdiGuncelle(guncellenecekElement);

    this.ortak.storageProgramAyarEkle(guncellenecekElement);
    this.ortak.showBasicAlert("Bilgi", "Yazıcı  Kaydedidildi.");
    this.ayarlarigetir();

  }
  YazicilariGetir() {
    this.bllOrtak.islemWithoutPost("YazicilariVer", "", false).then(a => {
      var sonuc = <any>a;
      this.yaziciListesi = sonuc.SonucObject;

    })
  }
  
  
  Kapat()
  {
    this.navCtrl.setRoot(YonetimAnaSayfaPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/program-ayarlari/program-ayarlari.ts